export default __webpack_public_path__ + "static/media/roadmap6.fc23781c.jpg";